import { runtimeEnv } from '@/lib/runtimeEnv';

// Its own module so the v1 client can read it while BackendClient is still loading (they import each other)
export const BACKEND_URL = (runtimeEnv.VITE_BACKEND_URL || process.env.VITE_BACKEND_URL) as string;
export const API_KEY = (runtimeEnv.VITE_LUREO_API_KEY || process.env.VITE_LUREO_API_KEY) as string;

if (!BACKEND_URL) throw new Error('VITE_BACKEND_URL environment variable is not set');

/** Which backend this build talks to, from its URL: a local one, staging, or production. */
export const BACKEND_ENVIRONMENT: 'local' | 'staging' | 'production' = BACKEND_URL.includes('localhost') ? 'local' : BACKEND_URL.includes('staging') ? 'staging' : 'production';
if (!API_KEY) throw new Error('VITE_LUREO_API_KEY environment variable is not set');
